import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/support")({
  head: () => ({
    meta: [
      { title: "Support, Knot" },
      { name: "description", content: "Get help with Knot, the warm CBT reframing journal." },
      { property: "og:title", content: "Support, Knot" },
      { property: "og:description", content: "Get help with Knot, the warm CBT reframing journal." },
    ],
  }),
  component: SupportPage,
});

function SupportPage() {
  return (
    <div className="min-h-dvh" style={{ background: "#EFE7DB" }}>
      <div className="mx-auto max-w-2xl px-5 py-10 pb-[max(2.5rem,env(safe-area-inset-bottom))]">
        <Link to="/" className="text-sm font-semibold" style={{ color: "#7A4FE0" }}>
          ← Back to Knot
        </Link>
        <div
          className="mt-4 rounded-3xl p-6 sm:p-8"
          style={{ background: "#FBF7F0", border: "1px solid #E6DDCB" }}
        >
          <div className="text-[11px] font-extrabold tracking-[0.18em] uppercase" style={{ color: "#7A4FE0" }}>
            Support
          </div>
          <h1 className="mt-2 text-3xl font-extrabold leading-tight text-[#2E2438]">
            We're here to help
          </h1>
          <p className="mt-3 text-[15px] leading-relaxed text-[#4E445A]">
            Knot is a small, warm CBT reframing journal. If something isn't working, if you'd like
            to delete your data, or if you have feedback about the experience, please reach out and
            we'll get back to you.
          </p>

          <a
            href="mailto:umer.w.iqbal@gmail.com?subject=Knot%20support"
            className="mt-6 inline-flex h-12 items-center justify-center rounded-full px-6 text-sm font-extrabold text-white press"
            style={{ background: "#7A4FE0" }}
          >
            Email umer.w.iqbal@gmail.com
          </a>

          <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-[#4E445A]">
            <section>
              <h2 className="text-lg font-extrabold text-[#2E2438]">Common questions</h2>
              <div className="mt-3 space-y-4">
                <div>
                  <div className="font-semibold text-[#2E2438]">Do I need to make an account?</div>
                  <p className="mt-1">
                    No. Knot signs you in anonymously on your device the first time you open it, so
                    your entries persist without a name or email.
                  </p>
                </div>
                <div>
                  <div className="font-semibold text-[#2E2438]">Does my writing get shared?</div>
                  <p className="mt-1">
                    Only the text you write during a session is sent to Google Gemini (via the
                    Lovable AI Gateway) so Knot can spot distortions and reply. It's not used to
                    train models. See the <Link to="/privacy" className="font-semibold" style={{ color: "#7A4FE0" }}>privacy policy</Link> for details.
                  </p>
                </div>
                <div>
                  <div className="font-semibold text-[#2E2438]">How do I delete my data?</div>
                  <p className="mt-1">
                    Email us and we'll remove your entries and profile from our backend.
                  </p>
                </div>
                <div>
                  <div className="font-semibold text-[#2E2438]">I lost my entries after clearing my browser.</div>
                  <p className="mt-1">
                    Because Knot has no login, your anonymous session lives in your browser's
                    storage. Clearing site data signs you out and previous entries can't be
                    recovered from a new session.
                  </p>
                </div>
                <div>
                  <div className="font-semibold text-[#2E2438]">I'm in crisis.</div>
                  <p className="mt-1">
                    Knot isn't a substitute for professional care. If you're in danger or crisis,
                    please contact the 988 Suicide & Crisis Lifeline (US) or your local emergency
                    services.
                  </p>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-8 flex flex-wrap gap-3 text-sm">
            <Link to="/privacy" className="font-semibold" style={{ color: "#7A4FE0" }}>Privacy →</Link>
            <Link to="/" className="font-semibold" style={{ color: "#7A4FE0" }}>Back to Knot →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
